import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import GrantSearchForm from './GrantSearchForm';
import SearchView from "../../../widgets/SearchView";
import withMenuPermission from "../../../widgets/withMenuPermission";
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "../../../ViewUtils";

const utils = new ViewUtils();
const toolbarRef = React.createRef();

const headCells = [
    { id: 'ProjectNumber', numeric: false, disablePadding: false, label: 'Project Number' },
    { id: 'FinancialYear', numeric: false, disablePadding: false, label: 'Time Period' },
    { id: 'DiscretionaryGrantType', numeric: false, disablePadding: false, label: 'Intervention Type' },
/*    { id: 'VendorSDLNumber', numeric: false, disablePadding: false, label: 'Vendor SDL Number' },*/
    { id: 'SocioEconomicStatus', numeric: false, disablePadding: false, label: 'Employment' },
    { id: 'Programme', numeric: false, disablePadding: false, label: 'Intervention' }
];


class GrantSetupSearch extends Component {

    constructor(props) {
        super(props);

        

        this.state = {
            selectedGrant: null,
            model: {
                FinancialYearID: null,
                DiscretionaryGrantTypeID: null,
                Client: null
            },
            keyUpSwitch: false

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Create New', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedGrant) },
                        { id: 'delete', label: '', tooltip: 'Remove Grant', icon: 'DeleteIcon', visible: this.props.menuPermissionItem.Delete, disabled: utils.isNull(this.state.selectedGrant) }
                    ]
                }
            ]
        };

    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedGrant: selection })
        } else {
            this.setState({ selectedGrant: null })
        }
        toolbarRef.current.setButtonDisabled("edit", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("delete", selection === null || selection.length === 0);
    }

    handleFormValueChange = (values) => {
        if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
            this.setState({ model: values, selectedGrant: null });
            toolbarRef.current.setButtonDisabled("edit", true);
            toolbarRef.current.setButtonDisabled("delete", true);
        }
    }

    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "add") {
            this.props.history.push({
                pathname: '/AddEditTranche',
                state: {
                    TrancheID: 0,
                    hideFields: true
                }
            })
        }
        else if (buttonId === "edit") {
            this.props.history.push({
                pathname: '/AddEditTranche',
                state: {
                    TrancheID: this.state.selectedGrant[0].Id,
                    hideFields: false
                }
            })
        }
    }

    render() {

        return (
            <ViewContainer  title="">
                <SearchView headCells={headCells}
                    dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/GrantSetup/GetSearch"}
                    entityViewPath='/grant'
                    addViewPath='/addGrant'
                    model={this.state.model} toolbarConfig={this.toolbarConfig} searchParameters={this.searchParameters}
                    onLookupValueChange={this.props.onLookupValueChange} deleteUrl={"api/sims/GrantSetup/DeleteTrancheSetup"}
                    useDeletePost={true}
                    toolbarRef={toolbarRef}
                    history={this.props.history}
                    searchLabel={"SEARCH"}
                    title='Project Setup'
                    descriptionProp="ProjectNumber"
                    handleObject={true}
                    autoFetchData={false}
                    keyUpSwitch={this.state.keyUpSwitch}
                    promptTitle={"Remove Project"}
                    promptContent={"Are you sure you want to remove this project?"}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                >
                    <GrantSearchForm data={this.state.model}
                        valueChangeHandler={(values) => this.handleFormValueChange(values)} mode={this.props.mode} />
                </SearchView>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(GrantSetupSearch));



